import React, { useState } from 'react';
import { Paragraph, Tab, Tabs, Box, Text, TextInput, Image, Layer, Button } from 'grommet';
import { PageHeader, Page, PageContent, Heading } from 'grommet';
import { MapTabContent } from '../../components/MapTabContent';
import { ValueStreamsGrid } from '../valuestreams/ValueStreamsGrid';
import { OwnershipModelGrid } from '../governance/OwnershipModelGrid';
import { NorthStarGrid } from '.';
import './page.css';

const searchSuggestions = [
  'Sales & Marketing', 'Source, Make & Deliver', 'Billing & Accounting', 'Support & Retention',
  'CPQ', 'Integration Fabric', 'Data Platform', 'SAP', 'SAP S/4', 'SAP BRIM', 'SAP Commerce',
  'SAP Ariba', 'SAP GTS', 'Salesforce Sales Cloud', 'Salesforce Service Cloud', 'Testing Automation',
  'Hybrid Cloud', 'Infrastructure', 'Data & AI', 'Supply Chain',
];

export const RoadmapsHome = () => {
  const [isFocused, setIsFocused] = useState(false);
  const [activeProductTab, setActiveProductTab] = useState(0);
  const [activePlatformTab, setActivePlatformTab] = useState(0);
  const [activeNorthStarTab, setActiveNorthStarTab] = useState(0);
  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState(searchSuggestions.slice(0, 5));
  const [showImageModal, setShowImageModal] = useState(false); // State for modal visibility

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const filterResults = query => {
    const regexp = new RegExp(query, 'i');
    return query ? searchSuggestions.filter(option => regexp.test(option)) : searchSuggestions;
  };

  const onChange = event => {
    const nextValue = event.target.value;
    setValue(nextValue);
    setSuggestions(filterResults(nextValue).slice(0, 5));
  };

  const onSuggestionSelect = () => {
    window.location.href = '/roadmap-display'; // Temp...
  };

  // Handle image click to show full-screen modal
  const handleImageClick = () => {
    setShowImageModal(true);
  };

  // Handle modal close
  const handleCloseModal = () => {
    setShowImageModal(false);
  };

  return (
    <Page flex="grow" background="background">
      <Box background="url('/images/space-background.png')" height="140px">
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader 
            pad={{ top: '5px', bottom: '10px' }}
            title={<Text color="white" size="xxlarge" weight="bolder">Welcome to HPE's Internal Road Map Explorer</Text>}
            subtitle="Innovation and transformation journey insights."
            size="medium"
            style={{ color: 'white' }}
          />
          <TextInput
            className="custom-placeholder"
            aria-label="search"
            placeholder={<Text color="white">Display by value stream, capability, etc.</Text>}
            onFocus={handleFocus}
            onBlur={handleBlur}
            style={{ borderColor: isFocused ? 'green' : 'white', color: 'white' }}
            reverse
            suggestions={suggestions}
            onSuggestionSelect={onSuggestionSelect}
            value={value}
            onChange={onChange}
            type="search"
            width="medium"
            margin={{ bottom: '10px' }}
          />
        </Box>
      </Box>

      <PageContent flex="grow" background="background" width="80%">
        <Heading size="medium" margin={{ top: 'medium' }}>Explore our <b>North Star</b></Heading>

        <Tabs activeIndex={activeNorthStarTab} onActive={setActiveNorthStarTab} justify="start">
          <Tab title="Vision">
            <MapTabContent>
              <Box
                direction="row"
                width="100%"
                pad={{ top: '0px' }}
                flex="grow"
                wrap
              >
                {/* Left side text */}
                <Box
                  flex="1"
                  justify="start"
                  align="start"
                  pad={{ left: 'small', right: 'medium' }}
                  overflow="hidden"
                >
                  <Box direction="column" width="100%" pad={{ top: 'none', bottom: 'none' }} align="start">
                    <Heading level={1} pad="none" margin="none" textAlign="start">
                      HPE IT's Strategic Vision
                    </Heading>

                    {/* Paragraph beneath the header */}
                    <Text size="medium" margin="none" wordWrap="break-word" textAlign="start">
                      Paragraph to come here
                    </Text>
                  </Box>
                </Box>

                {/* Right side image with click event for full-screen */}
                <Box
                  flex="1"
                  justify="center"
                  align="center"
                  pad={{ horizontal: 'small' }}
                  overflow="hidden"
                >
                  <Image
                    fit="contain"
                    src="/images/overall-it-vision.png"
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxWidth: '100%',
                      cursor: 'pointer', // Indicate clickable area
                    }}
                    onClick={handleImageClick} // Open image in modal on click
                  />
                </Box>
              </Box>
            </MapTabContent>
          </Tab>

          <Tab title="Value Streams & Platforms">
            <NorthStarGrid />
          </Tab>
          <Tab title="Ownership Model">
            <OwnershipModelGrid />
          </Tab>
          <Tab title="Key Transitions">
            <MapTabContent>
              <Paragraph margin="none">Coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
        </Tabs>

        <ValueStreamsGrid isVerticalGrid={true} isGridExpanded={false} />

        <Heading size="medium" margin={{ top: 'large' }}>Explore by <b>Product</b></Heading>
        <Tabs activeIndex={activeProductTab} onActive={setActiveProductTab} justify="start">
          <Tab title="eCommerce">
            <MapTabContent>
              <Paragraph margin="none">eCommerce top roadmap priorities coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          <Tab title="Salesforce">
            <MapTabContent>
              <Paragraph margin="none">Salesforce roadmap priorities coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          <Tab title="SAP">
            <MapTabContent>
              <Paragraph margin="none">SAP roadmap priorities coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          {/* Other product tabs */}
        </Tabs>

        <Heading size="medium" margin={{ top: 'large' }}>Explore by major <b>Platform</b></Heading>
        <Tabs activeIndex={activePlatformTab} onActive={setActivePlatformTab} justify="start">
          <Tab title="IT Hybrid Cloud">
            <MapTabContent>
              <Paragraph margin="none">IT's hybrid cloud top roadmap priorities coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          <Tab title="Data Platform">
            <MapTabContent>
              <Paragraph margin="none">Data Platform roadmap priorities coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          <Tab title="SAP S/4">
            <MapTabContent>
              <Paragraph margin="none">SAP S/4 roadmap priorities coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          <Tab title="Salesforce Cloud">
            <MapTabContent>
              <Paragraph margin="none">Salesforce Cloud roadmap priorities coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          {/* Other platform tabs */}
        </Tabs>
      </PageContent>

      {/* Full-screen Image Modal */}
      {showImageModal && (
        <Layer
          onEsc={handleCloseModal}
          onClickOutside={handleCloseModal}
          full={true}
        >
          <Box
            fill
            justify="center"
            align="center"
            background="dark-1"
            pad="medium"
          >
            <Button
              label="Close"
              onClick={handleCloseModal}
              primary
              style={{ position: 'absolute', top: '20px', right: '20px' }}
            />
            <Image
              fit="contain"
              src="/images/overall-it-vision.png"
              style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
          </Box>
        </Layer>
      )}
    </Page>
  );
};




